export default {
  'commissionmanagement.commissionmanagement': 'Points Management',
  'commissionmanagement.accountsnotify':
    'Please Manage Your Bank Accounts From',
  'commissionmanagement.accountsnotify1': 'Link.',
  'commissionmanagement.accountmanagement': 'Banks Account management',
  'commissionmanagement.description': 'Description',
  'commissionmanagement.bankaccount': 'Account No',
  'commissionmanagement.save': 'Save',
  'commissionmanagement.addrequest': 'Point To Money',
  'commissionmanagement.withdrawamount': 'Withdraw Points',
  'commissionmanagement.index': 'Index',
  'commissionmanagement.requestdate': 'Request Date',
  'commissionmanagement.requeststatus': 'Request Status',
  'commissionmanagement.withdrawtype': 'Withdraw Type',
  'commissionmanagement.requestadd': 'Withdraw Request Is Added Successfully',
  'commissionmanagement.tryagain': 'Please Try Again',
  'commissionmanagement.deleterequest': 'Delete Withdraw Request',
  'commissionmanagement.deleteerror': 'Can Not Delete This Request',
  'commissionmanagement.disapprove': 'DisApprove',
  'commissionmanagement.approve': 'Approve',
  'commissionmanagement.disapprove': 'disapprove',
  'commissionmanagement.pending': 'Pending',
  'commissionmanagement.notpaid': 'Not Paid',
  'commissionmanagement.paid': 'Paid',
  'commissionmanagement.showdetail': 'Show Details',
  'commissionmanagement.incomedetail': 'Income Details',
  'commissionmanagement.withdrawreport': 'Transactions Report',
  'commissionmanagement.transferpoints': 'Transfer Point',
  'commissionmanagement.buycard': 'Buy recharge cards',
  'commissionmanagement.paybill': 'Pay Bill',
  'commissionmanagement.spendpoints': 'Spend Point',
  'commissionmanagement.transfermoney': 'Transfer Money',
  'commissionmanagement.lottery': 'Loterry',
  'commissionmanagement.earnpoints': 'Earning Points',
  'commissionmanagement.redandantrequest':
    "There is one pending request.Please don't send another request",
  'commissionmanagement.exitfee': 'Exit Fee',
  'commissionmanagement.exitTax': 'Exit Taxes',
  'commissionmanagement.requestreport': 'Withdraw Requests Report',
  'commissionmanagement.phrase': 'Document number',
  'commissionmanagement.documentdescription': 'Document Description',
  'commissionmanagement.transferamount': 'Transferable points',
  'commissionmanagement.pointamount': 'Point Amount',
  'commissionmanagement.secondpassword': 'Second Password',
  'commissionmanagement.transfererror':
    'The amount of requested points is more than the amount of remaining points',
  'commissionmanagement.transfernotify':
    'Dear user to transfer points, please use the ',
  'commissionmanagement.transfernotify1': 'Link.',
  'commissionmanagement.addsecondpassword': 'Add Second Password',
  'commissionmanagement.resecondpassword': 'Re-Second Password',
  'commissionmanagement.wagenotify1': 'Do you agree to deduct ',
  'commissionmanagement.wagenotify2': 'point for the wage? ',
  'commissionmanagement.errorsecondpassword':
    'The second password is not registered. Please add the second password first',
  'commissionmanagement.wrongsecondpassword': 'The second password is Wrong',
  'commissionmanagement.successtransfer': 'Points successfully transferred',
  'commissionmanagement.notenoughpoint':
    'The requested points are not allowed due to your suspended points',
  'commissionmanagement.sameprofiles': 'Sender is the same as reciever',
  'commissionmanagement.InternalServer': 'Internal server error',
  'commissionmanagement.deleteconfirm':
    'Are you sure to delete point withdraw request?',
  'commissionmanagement.deletesucess':
    'Withdraw request was deleted successfully',
  'commissionmanagement.customer': 'Customers',
  'commissionmanagement.employee': 'Employees',
  'commissionmanagement.request': 'Requests',
  'commissionmanagement.income': 'Your Income',
  'commissionmanagement.wallet': 'Upgrade Your Wallet',
  'commissionmanagement.customerregion': 'Customer based region',
  'commissionmanagement.totalpoint': 'Total Points',
  'commissionmanagement.requestprice': 'Requested Amount',
  'commissionmanagement.sendsms': 'Send SMS',
  'commissionmanagement.requestpoint': 'Requested Point',
  'commissionmanagement.wallettransaction': 'Last Wallet Transactions',
  'commissionmanagement.recenttransactions': 'Recent Transactions',
  'commissionmanagement.pointtransactions': 'Point Transactions',
  'commissionmanagement.transitional': 'Transitional',
  'commissionmanagement.exitfeepayment': 'Pay Taxes',
  'commissionmanagement.moneydescription':
    'You can convert your points into money and deposit it in your bank account.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'In this way, you can transfer your points to Tripsi users.',
  'commissionmanagement.transferpointdescriptionTripord':
    'In this way, you can transfer your points to Tripord users.',
  'commissionmanagement.getpointdescription':
    'There are several ways to increase your points and have free trips.',
  'commissionmanagement.spendpointdescription':
    'You can use your points in different sections and have free services.',
  'commissionmanagement.buycarddescription':
    'Through the points, you can receive the card of Hamrah Aval ,Irancell and Taliya for free.',
  'commissionmanagement.buyCard': 'Buy Card',
  'commissionmanagement.exitfeedescription':
    'With your points, you can pay exit taxes.',
  'commissionmanagement.buypoint': 'Buy Point',
  'commissionmanagement.safeway': 'The safest way',
  'commissionmanagement.spendanywhere': 'Spend anywhere',
  'commissionmanagement.deposit': 'Deposit to account',
  'commissionmanagement.easyway': 'The easiest way',
  'commissionmanagement.fastway': 'The fastest way',
  'commissionmanagement.entersecondpassword': 'Enter second password',
  'commissionmanagement.usepoint': 'My dear friend, use the points well',
  'commissionmanagement.textTransferpoints':
    'You can transfer your points to another user account through the form below .',
  'commissionmanagement.textRequest':
    'You can convert your points into money through the form below .',

  'commissionmanagement.textDetails':
    'You can view or edit the details of the desired user through the following form .',
};
